import { useSession } from './useSession'

type Resource =
  | 'installation'
  | 'productionRoute'
  | 'emissionReport'
  | 'precursor'
  | 'importerRequest'
  | 'precursorRequest'
  | 'materialManagement'
  | 'organization'
  | 'integration'
  | 'internal'

type Action = 'create' | 'read' | 'update' | 'delete' | 'share' | 'submit' | 'manage-users'

const CHALCO_ORG_ID = import.meta.env.VITE_CHALCO_ORG_ID

export const usePermissions = () => {
  const { session } = useSession()
  const organizationId = session?.organization?.id
  const permissions = [
    ...(session?.permissions || []),
    ...(organizationId === CHALCO_ORG_ID ? ['integration:*'] : [])
  ]
  const checkPermission = (resource: Resource, action: Action) => {
    const perm = `${resource}:${action}`
    return (
      permissions.includes(perm) || // Exact match
      permissions.includes(`${resource}:*`) // Wildcard match (e.g., "installation:*")
    )
  }

  return {
    checkPermission
  }
}
